import { render, staticRenderFns } from "./paiement.vue?vue&type=template&id=e87b37cc&scoped=true&"
import script from "./paiement.vue?vue&type=script&lang=js&"
export * from "./paiement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87b37cc",
  null
  
)

export default component.exports